module.exports = __webpack_public_path__ + "images/services/kiln-preview-logo.4cb66777717e573fbeb6.svg";